import * as d3 from 'd3'

export default {
  methods: {
    

    call_Link(selection, d_, type_) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', 0.5)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1)
      })
      .on('click', () => {
        this.link_Modal(d_, type_)
      }) 
    }, 

    link_Modal(d_, type_) {

      // set for link key value   ex) let dataSource = {KEY1:d.PKG,KEY2:d.DISC...}
      let dataSource = {KEY_GROUP: d_.GROUP, KEY_ITEM: d_.ITEM} // DO not Remark if possible

      // set for request from A/G jsonProps
      let request_ = this.getRequestColumnProps(d_.GROUP, dataSource, this.ColumnProps)
      if(!request_) return

      // set for filterString 
      let filterString_ = ''

      if (type_ == 'MONTH') {
        filterString_ += this.styles.filter.f1.replaceAll('@cutoff', `'${this.cutoff}'`)
      }

      // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // combine filterString and inputFilter &&& emit request-action
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },


  }
}